import React, { Component }  from 'react';
import '../../style.css';
import {
    Button,
    Card,
    Form,
    Input,
    Modal,
    Space,
    Table,
    message,
    DatePicker,
    Radio,
    Typography,
    PageHeader, Select
} from "antd";
import {DeleteOutlined, EditOutlined,SearchOutlined} from "@ant-design/icons";
import {fetchPost} from "../../static/util/fetch";
import moment from "moment";
import 'moment/locale/zh-cn';
const {Column} =Table;
const { Paragraph } = Typography;
const Option = Select.Option;
class ProjectList extends Component {
    constructor(props) {
        super(props);
        this.state={
            loading:false,
            projectNames:[],// 项目列表
            companyNames:[],//公司名称列表
            productNames:[],//产品名称数组
            addProductNames:[],//添加时产品名称数组
            companyName:'请选择公司',//添加时选中的公司名称
            productName:'请选择产品',//添加时选中的产品名称
            addCompanyName:'请选择公司',//添加时选中的公司名称
            addProductName:'请选择产品',//添加时选中的产品名称
            companyId:0,
            addCompanyId:0,
            productId:0,
            addProductId:0,
            projectName:'',
            projectCode:'',
            projectStartTime:'',
            projectEndTime:'',
            expense:'',
            finish:"",
            edit_visible:false,//编辑弹窗状态
            add_visible:false,//添加公司弹窗状态
            delete_visible:false,//删除弹窗状态
            newProjectName:'',
            newProjectCode:'',
            newProjectStartTime:'',
            newProjectEndTime:'',
            newExpense:'',
            newFinish:'',
            editId:0,
            deleteId:0,
            deleteProductName:'',
            searchStatus:true,
        }
        this.handleAddClick = this.handleAddClick.bind(this);
        this.uploadProject = this.uploadProject.bind(this);
        this.deleteProject=this.deleteProject.bind(this);
        this.addProject=this.addProject.bind(this);
        this.hideModal=this.hideModal.bind(this);
        this.handleEditClick=this.handleEditClick.bind(this);
        this.getProjectList=this.getProjectList.bind(this);
        this.handleDeleteClick=this.handleDeleteClick.bind(this);
        this.projectNameChange=this.projectNameChange.bind(this);
        this.projectNameChangeNew=this.projectNameChangeNew.bind(this);
        this.productNameChange=this.productNameChange.bind(this);
        this.projectCodeChange=this.projectCodeChange.bind(this);
        this.finishChange = this.finishChange.bind(this);
        this.projectCodeChangeNew=this.projectCodeChangeNew.bind(this);
        this.projectStartTimeChange=this.projectStartTimeChange.bind(this);
        this.projectStartTimeChangeNew=this.projectStartTimeChangeNew.bind(this);
        this.projectEndTimeChange=this.projectEndTimeChange.bind(this);
        this.projectEndTimeChangeNew=this.projectEndTimeChangeNew.bind(this);
        this.finishChangeNew  = this.finishChangeNew.bind(this);
        // this.cancelCompanyName=this.cancelCompanyName.bind(this);
        // this.cancelProductName=this.cancelProductName.bind(this);
    }
    componentDidMount() {
        //获取登录用户的所有项目
        // this.setState(()=>({
        //    loading:true
        // }))
        // fetchPost(global.constants.getAllProject,{})
        //     .then(
        //         res => {
        //             if(res.code === 200) {
        //                 this.setState(()=>({
        //                     projectNames:res.data,
        //                     loading:false
        //                 }))
        //             }
        //             else{
        //                 this.setState(()=>({
        //                     loading:false
        //                 }))
        //                message.info(res.msg).then()
        //             }
        //         }
        //     )
        //获取用户全部公司名称
        fetchPost(global.constants.getCompanyNameList,{id:this.props.id})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            companyNames:res.data,
                        }))
                    }
                    else{
                        message.info(res.msg).then()
                    }
                }
            )
    }
    clearPath(){
        this.setState(()=>({
            companyName:'请选择公司',
            productName:'请选择产品',
            searchStatus:true,
        }))
    }
    getProjectList () {
        this.setState(()=>({
            loading:true,
        }))
        if(this.state.productName==='请选择产品'&&this.state.companyName==='请选择公司'){
            message.info('请选择查找路径').then()
            this.setState(()=>({
                loading:false
            }))
        }
        if(this.state.productName==='请选择产品'&&this.state.companyName!=='请选择公司'){
            let params ={
                companyId: this.state.companyId,
            }
            fetchPost(global.constants.getProjectByCompany,params)
                .then(
                    res => {
                        if(res.code === 200) {
                            this.setState(()=>({
                                projectNames:res.data,
                                loading:false,
                                searchStatus:false,
                            }))
                        }
                        else{
                            this.setState(()=>({
                                projectNames:[],
                                loading:false,
                                searchStatus:false,
                            }))
                            message.info("该路径下未添加项目").then()
                        }
                    }
                )

        }
        if(this.state.productName!=='请选择产品'&&this.state.companyName!=='请选择公司'){
            let params ={
                companyId: this.state.companyId,
                productId: this.state.productId,
            }
            fetchPost(global.constants.getProjectByProduct,params)
                .then(
                    res => {
                        if(res.code === 200) {
                            this.setState(()=>({
                                projectNames:res.data,
                                loading:false,
                                searchStatus:false,
                            }))
                        }
                        else{
                            this.setState(()=>({
                                projectNames:[],
                                loading:false,
                                searchStatus:false,
                            }))
                            message.info("该路径下未添加项目").then()
                        }
                    }
                )
        }
    }
    hideModal(){
        //关闭弹窗
        this.setState(()=>({
            add_visible:false,
            edit_visible:false,
            delete_visible:false,
        }))
    }

    handleEditClick=(e)=>{
        const value = e.id;
        //打开编辑窗口
        this.setState(()=>({
            editId:value,
        }))
        //这里不能把e.id存到state中，因为setState和下面的fetchPost是异步的
        fetchPost(global.constants.getProjectMessage,{id:value})
            .then(
                res =>{
                    console.log(res)
                    if(res.code === 200){
                        this.setState(()=>({
                            newProjectName: res.data.projectName,
                            newProjectCode:res.data.projectCode,
                            newProjectStartTime:res.data.projectStartTime,
                            newProjectEndTime:res.data.projectEndTime,
                            newExpense:res.data.expense,
                            newFinish:res.data.finish,
                            edit_visible:true,
                        }))
                    }
                }
            )

    }
    uploadProject(){
        let params = {
            id:this.state.editId,
            projectName:this.state.newProjectName,
            projectCode:this.state.newProjectCode,
            projectStartTime:this.state.newProjectStartTime,
            projectEndTime:this.state.newProjectEndTime,
            expense:this.state.newExpense,
            finish:this.state.newFinish,
        }
        fetchPost(global.constants.updateProject,params)
            .then(
                res => {
                    if(res.code === 200){
                        message.success(res.msg).then()
                        this.setState(()=>({
                            edit_visible:false
                        }))
                        if(this.state.productName==='请选择产品'&&this.state.companyName!=='请选择公司'){
                            let params ={
                                companyId: this.state.companyId,
                            }
                            fetchPost(global.constants.getProjectByCompany,params)
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                projectNames:res.data,
                                            }))
                                        }
                                        else{
                                            message.info("没有绑定的项目").then()
                                        }
                                    }
                                )

                        }
                        if(this.state.productName!=='请选择产品'&&this.state.companyName!=='请选择公司'){
                            let params ={
                                companyId: this.state.companyId,
                                productId: this.state.productId,
                            }
                            fetchPost(global.constants.getProjectByProduct,params)
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                projectNames:res.data,
                                            }))
                                        }
                                        else{
                                            message.info("没有绑定的项目").then()
                                        }
                                    }
                                )
                        }
                        // window.location.reload()
                    }
                    else {
                        message.error("修改失败").then()
                    }
                }
            )
    }
    handleDeleteClick=(e)=>{
        const value_id = e.id;
        const value_projectName = e.projectName;
        this.setState(()=>({
            delete_visible:true,
            deleteId:value_id,
            deleteProductName:value_projectName,
        }))
    }
    deleteProject(){
        let params = {
            id:this.state.deleteId,
        }
        fetchPost(global.constants.deleteProject,params)
            .then(
                res => {
                    console.log(res.code)
                    if(res.code === 200){
                        message.success('删除项目成功').then()
                        this.setState(()=>({
                            delete_visible:false
                        }))
                        if(this.state.productName==='请选择产品'&&this.state.companyName!=='请选择公司'){
                            let params ={
                                companyId: this.state.companyId,
                            }
                            fetchPost(global.constants.getProjectByCompany,params)
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            console.log(res)
                                            this.setState(()=>({
                                                projectNames:res.data,
                                            }))
                                        }
                                        else{
                                            this.setState(()=>({
                                                projectNames:[],
                                            }))
                                            message.error("没有绑定的项目").then()
                                        }
                                    }
                                )
                        }
                        if(this.state.productName!=='请选择产品'&&this.state.companyName!=='请选择公司'){
                                let params ={
                                    companyId: this.state.companyId,
                                    productId: this.state.productId,
                                }
                                fetchPost(global.constants.getProjectByProduct,params)
                                    .then(
                                        res => {
                                            if(res.code === 200) {
                                                this.setState(()=>({
                                                    projectNames:res.data,
                                                }))
                                            }
                                            else{
                                                this.setState(()=>({
                                                    projectNames:[],
                                                }))
                                                message.error("没有绑定的项目").then()
                                            }
                                        }
                                    )
                            }
                    }
                    else{
                        if(res.code === -1){
                            message.error("删除失败").then()
                        }
                    }
                }
            )
    }
    handleAddClick(e){
        //打开添加公司弹窗
        const value =e.id
        this.setState(()=>({
            editId:value,
            add_visible:true,
            addCompanyName:"请选择公司",
            addProductName:'请选择产品',
            projectName:'',
            projectCode:'',
            projectStartTime:'',
            projectEndTime:'',
            expense:'',
            finish:'',
        }))
    }
    checkProject(){
        fetchPost(global.constants.checkProjectName,{projectName:this.state.projectName})
            .then(
                res=>{
                    if(res.code === -1){
                        alert("该项目已存在")
                    }
                }
            )
    }
    addProject(){
        let params = {
            companyId:this.state.addCompanyId,
            productId:this.state.addProductName==='请选择产品'?0:this.state.addProductId,
            projectCode:this.state.projectCode,
            projectName:this.state.projectName,
            projectStartTime:this.state.projectStartTime,
            projectEndTime:this.state.projectEndTime,
            expense:this.state.expense,
            finish:this.state.finish,
        }
        if(this.state.addCompanyName ==='请选择公司'){
            message.error("请先选择公司再添加项目").then()
        }
        else{
            if(this.state.projectName === ''||this.state.projectCode === ''||this.state.projectStartTime=== ''||
                this.state.projectEndTime === ''||this.state.expense === ''||this.state.finish === ''){
                message.info("请检查项目信息是否填写完整").then()
            }else {
                fetchPost(global.constants.addProject, params)
                    .then(
                        res => {
                            if (res.code === 200) {
                                message.success('添加成功').then()
                                this.setState(() => ({
                                    add_visible: false
                                }))
                                if(this.state.addProductName==='请选择产品'&&this.state.addCompanyName!=='请选择公司'){
                                    this.setState(()=>({
                                        companyName:this.state.addCompanyName,
                                        productName:this.state.addProductName,
                                        companyId:this.state.addCompanyId,
                                        productId:this.state.addProductId
                                    }))
                                    fetchPost(global.constants.getProjectByCompany, {companyId: this.state.addCompanyId})
                                        .then(
                                            res => {
                                                if(res.code === 200) {
                                                    this.setState(()=>({
                                                        projectNames:res.data,
                                                    }))
                                                }
                                                else{
                                                    this.setState(()=>({
                                                        projectNames:[],
                                                    }))
                                                }
                                            }
                                        )

                                }
                                if(this.state.addProductName!=='请选择产品'&&this.state.addCompanyName!=='请选择公司'){
                                    this.setState(()=>({
                                        companyName:this.state.addCompanyName,
                                        productName:this.state.addProductName,
                                        companyId:this.state.addCompanyId,
                                        productId:this.state.addProductId
                                    }))
                                    let params ={
                                        companyId: this.state.addCompanyId,
                                        productId: this.state.addProductId,
                                    }
                                    fetchPost(global.constants.getProjectByProduct,params)
                                        .then(
                                            res => {
                                                if(res.code === 200) {
                                                    this.setState(()=>({
                                                        projectNames:res.data,
                                                    }))
                                                }
                                                else{
                                                    this.setState(()=>({
                                                        projectNames:[],
                                                    }))
                                                }
                                            }
                                        )
                                }
                            } else {
                                if (res.code === -1) {
                                    message.error(res.msg).then()
                                }
                            }
                        }
                    )
            }
        }
    }
    chooseCompany = (e)=>{
        const value = e
        this.setState(()=>({
            companyName:value,
            productName:'请选择产品'
        }))
        this.state.companyNames.find((obj) => {
                if (obj.companyName === value) {
                    this.setState(() => ({
                        companyId: obj.id
                    }))
                    fetchPost(global.constants.getCompanyProductList, {companyId: obj.id})
                        .then(
                            res => {
                                if (res.code === 200) {
                                    this.setState(() => ({
                                        productNames: res.data,
                                    }))
                                } else {
                                    message.info("该公司没有产品").then()
                                    this.setState(() => ({
                                        productNames: [],
                                    }))
                                }
                            }
                        )
                }
            }
        )
    }
    chooseProduct = (e)=>{
        const value = e
        this.setState(()=>({
            productName:value
        }))
        this.state.productNames.find((obj) => {
            if (obj.productName === value) {
                this.setState(() => ({
                    productId: obj.id
                }))
            }
        }
        )
    }
    // cancelCompanyName(){
    //     this.setState(()=>({
    //         companyName:'请选择公司',
    //         productName:'请选择产品',
    //         productNames:[],
    //     }))
    //     fetchPost(global.constants.getAllProject,{})
    //         .then(
    //             res => {
    //                 if(res.code === 200) {
    //                     this.setState(()=>({
    //                         projectNames:res.data,
    //                     }))
    //                     console.log(this.state.projectNames)
    //                 }
    //                 else{
    //                     console.log("该用户没有项目")
    //                 }
    //             }
    //         )
    // }
    // cancelProductName(){
    //     this.setState(()=>({
    //         productName:'请选择产品'
    //     }))
    // }
    projectNameChange(e){
        this.setState(()=>({
            projectName:e
        }))
    }
    projectNameChangeNew(e){
        this.setState(()=>({
            newProjectName:e
        }))

    }
    productNameChange(e){
        this.setState(()=>({
            productName:e
        }))
    }
    projectCodeChange(e){
        this.setState({
            projectCode:e
        })
    }
    projectCodeChangeNew(e){
        this.setState({
            newProjectCode:e
        })
    }
    projectStartTimeChange=(value,dateString)=>{
        this.setState({
            projectStartTime:dateString
        })
    }
    projectStartTimeChangeNew=(value,dateString)=>{
        this.setState({
            newProjectStartTime:dateString
        })
    }
    projectEndTimeChange=(value,dateString)=>{
        this.setState({
            projectEndTime:dateString
        })
    }
    projectEndTimeChangeNew=(value,dateString)=>{
        this.setState({
            newProjectEndTime:dateString
        })
    }
    expenseChange(e){
        this.setState({
            expense:e
        })
    }
    expenseChangeNew(e){
        this.setState({
            newExpense:e
        })
    }
    finishChange(e){
        this.setState({
            finish:e
        })
    }
    finishChangeNew(e){
        this.setState({
            newFinish:e
        })
    }
    chooseAddCompany(e){
        const value = e
        this.setState(()=>({
            addCompanyName:value,
            addProductName:'请选择产品'
        }))
        this.state.companyNames.find((obj) => {
            if (obj.companyName === value) {
                this.setState(() => ({
                    addCompanyId: obj.id
                }))
                fetchPost(global.constants.getCompanyProductList, {companyId: obj.id})
                    .then(
                        res => {
                            if (res.code === 200) {
                                this.setState(() => ({
                                    addProductNames: res.data,
                                }))
                            } else {
                                message.info("该公司没有产品").then()
                                this.setState(() => ({
                                    addProductNames: [],
                                }))
                            }
                        }
                    )
            }
        })
    }
    chooseAddProduct(e){
        const value = e
        this.setState(()=>({
            addProductName:value
        }))
        this.state.productNames.find((obj) => {
                if (obj.productName === value) {
                    this.setState(() => ({
                        addProductId: obj.id
                    }))
                }
            }
        )
    }
    render() {
        return(
            <div className="content-frame">
                <div className="content-form">
                    <div className="content-page-header">
                        <PageHeader
                            ghost={false}
                            title="项目列表"
                            subTitle={"请选择公司与高新产品查找项目"}
                            extra={[
                                <Button
                                    type="primary"
                                    onClick={this.handleAddClick}
                                >
                                    添加项目
                                </Button>
                            ]}
                        >
                        </PageHeader>
                    </div>
                <Paragraph>
                    <pre>Tips：如果项目不属于任何产品，可以不选；选择完成后，点击查找。添加项目时同理。</pre>
                </Paragraph>
                <Space direction="vertical" className="content-style" >
                    <div>
                        <div>
                            <Select showSearch
                                    style={{ width: 300 }}
                                    placeholder="请选择公司"
                                    defaultValue={this.state.companyName}
                                    value={this.state.companyName}
                                    optionFilterProp="children"
                                    notFoundContent="无法找到"
                                    searchPlaceholder="输入关键词"
                                    onChange={this.chooseCompany.bind(this)}
                            >
                                {this.state.companyNames.map(item => (
                                    <Option key={item.companyName} value={item.companyName}>
                                        {item.companyName}
                                    </Option>
                                ))}
                            </Select>
                            <Select showSearch
                                    style={{ width: 300 }}
                                    placeholder="请选择产品"
                                    value={this.state.productName}
                                    optionFilterProp="children"
                                    notFoundContent="无法找到"
                                    searchPlaceholder="输入关键词"
                                    onChange={this.chooseProduct.bind(this)}
                            >
                                {this.state.productNames.map(item => (
                                    <Option key={item.productName} value={item.productName} >
                                        {item.productName}
                                    </Option>
                                ))}
                            </Select>
                            <Button
                                type="default"
                                className='Search_button'
                                icon={<SearchOutlined/>}
                                onClick={this.state.searchStatus === true ? this.getProjectList:this.clearPath.bind(this)}>
                                {this.state.searchStatus===true?'查找':'重新查找'}
                            </Button>
                        </div>
                        {/*<div>*/}
                        {/*    <Tag color="geekblue" className="Tag_style">{this.state.companyName}*/}
                        {/*        <Button*/}
                        {/*            size="small"*/}
                        {/*            type="dashed"*/}
                        {/*            shape="circle"*/}
                        {/*            style={{marginLeft:'5px'}}*/}
                        {/*            icon={<CloseOutlined style={{fontSize:'10px'}}/>}*/}
                        {/*            onClick={this.cancelCompanyName}*/}
                        {/*        />*/}
                        {/*    </Tag>*/}
                        {/*    <Tag color="orange" className="Tag_style">{this.state.productName}*/}
                        {/*        <Button*/}
                        {/*            size="small"*/}
                        {/*            type="dashed"*/}
                        {/*            shape="circle"*/}
                        {/*            style={{marginLeft:'5px'}}*/}
                        {/*            icon={<CloseOutlined style={{fontSize:'10px'}}/>}*/}
                        {/*            onClick={this.cancelProductName}*/}
                        {/*        />*/}
                        {/*    </Tag>*/}
                        {/*</div>*/}
                    </div>
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.projectNames} loading={this.state.loading}>
                            <Column
                                align="center"
                                title={<p className="list-column-style">序号</p>}
                                width="80"
                                render={(text,record,index)=>`${index+1}`} />
                            <Column
                                align="center"
                                title={<p className="list-column-style">项目名称</p>}
                                dataIndex="projectName"
                                key="projectName" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">项目编号</p>}
                                dataIndex="projectCode"
                                key="projectCode" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">项目起止时间</p>}
                                render={(text,record)=>record.projectStartTime+"-"+record.projectEndTime}
                                key="projectStartTime" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">操作</p>}
                                key="操作"
                                render={(text, record) => (
                                    <Space size="middle">
                                        <Button
                                            type="primary"
                                            icon={<EditOutlined />}
                                            onClick={this.handleEditClick.bind(this,record)}
                                        >编辑</Button>
                                        <Button
                                            type="primary"
                                            icon={<DeleteOutlined />}
                                            onClick={this.handleDeleteClick.bind(this,record)}
                                        >删除</Button>
                                    </Space>
                                )}
                            />
                        </Table>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.edit_visible}
                    title={'修改项目信息'}
                    onOk={this.uploadProject}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.uploadProject}>
                            提交
                        </Button>,
                    ]}
                >
                    <Form>
                        <Form.Item label="项目名称" name="productName">
                            <Input defaultValue={this.state.newProjectName} onChange={(e) => this.projectNameChangeNew(e.target.value)}/></Form.Item>
                        <Form.Item label="项目编号" name="projectCode">
                            <Input defaultValue={this.state.newProjectCode} onChange={(e) => this.projectCodeChangeNew(e.target.value)}/></Form.Item>
                        <Form.Item label="项目开始时间" name="projectStartTime">
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    defaultValue={moment(this.state.newProjectStartTime)} //默认值要求moment格式
                                    format={'YYYY-MM-DD'}
                                    onChange={this.projectStartTimeChangeNew}
                                />
                            </Space>
                        </Form.Item>
                        <Form.Item label="项目结束时间" name="projectEndTime">
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    defaultValue={moment(this.state.newProjectEndTime)} //默认值要求moment格式
                                    format={'YYYY-MM-DD'}
                                    onChange={this.projectEndTimeChangeNew}
                                />
                            </Space>
                        </Form.Item>
                        <Form.Item label="研发费用" name="expense">
                            <Input defaultValue={this.state.newExpense} style={{ width: 120}} onChange={(e) => this.expenseChangeNew(e.target.value)}/>
                            &nbsp;&nbsp;万元
                        </Form.Item>
                        <Form.Item label="是否结项" name="finish">
                            <Radio.Group
                                name="finish"
                                defaultValue={this.state.newFinish}
                                 onChange={(e) => this.finishChangeNew(e.target.value)}
                            >
                                <Radio value={"是"}>是</Radio>
                                <Radio value={"否"}>否</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.add_visible}
                    title={'添加项目'}
                    onOk={this.addCompany}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.addProject}>
                            提交
                        </Button>,
                    ]}
                >
                    <Form>
                        <Form.Item  name="choose" rules={[{ required: true, message: '请选择公司!' }]}>
                            <Select showSearch
                                    style={{ width: 300,bottom:5 }}
                                    value={this.state.addCompanyName}
                                    placeholder="请选择公司"
                                    optionFilterProp="children"
                                    notFoundContent="无法找到"
                                    searchPlaceholder="输入关键词"
                                    onSelect={this.chooseAddCompany.bind(this)}
                            >
                                {this.state.companyNames.map(item => (
                                    <Option key={item.companyName} value={item.companyName}>
                                        {item.companyName}
                                    </Option>
                                ))}
                            </Select>
                            <Select showSearch
                                    style={{ width: 300 }}
                                    value={this.state.addProductName}
                                    placeholder="请选择产品"
                                    optionFilterProp="children"
                                    notFoundContent="无法找到"
                                    searchPlaceholder="输入关键词"
                                    onChange={this.chooseAddProduct.bind(this)}
                            >
                                {this.state.addProductNames.map(item => (
                                    <Option key={item.productName} value={item.productName} >
                                        {item.productName}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="项目名称" name="projectName" rules={[{ required: true, message: '请输入项目名称!' }]}>
                            <Input
                                onChange={(e) => this.projectNameChange(e.target.value)}
                                // onBlur={this.checkProject.bind(this)}
                            /></Form.Item>
                        <Form.Item label="项目编号" name="projectCode" rules={[{ required: true, message: '请输入项目编号!' }]}>
                            <Input defaultValue={this.state.projectCode} onChange={(e) => this.projectCodeChange(e.target.value)}/></Form.Item>
                        <Form.Item label="项目开始时间" name="projectStartTime" rules={[{ required: true, message: '请输入项目开始时间!' }]}>
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    format={'YYYY-MM-DD'}
                                    onChange={this.projectStartTimeChange}
                                />
                            </Space>
                        </Form.Item>
                        <Form.Item label="项目结束时间" name="projectEndTime" rules={[{ required: true, message: '请输入项目结束时间!' }]}>
                            <Space direction="vertical" size={12}>
                                <DatePicker
                                    format={'YYYY-MM-DD'}
                                    onChange={this.projectEndTimeChange}
                                />
                            </Space>
                        </Form.Item>
                        <Form.Item label="研发费用" name="expense" rules={[{ required: true, message: '请输入研发费用!' }]}>
                            <Input defaultValue={this.state.expense} style={{ width: 120}} onChange={(e) => this.expenseChange(e.target.value)}/>
                            &nbsp;&nbsp;万元
                        </Form.Item>
                        <Form.Item label="是否结项" name="finish"  rules={[{ required: true, message: '请选择是否结项!' }]}>
                            <Radio.Group
                                name="finish"
                                onChange={(e) => this.finishChange(e.target.value)}
                            >
                                <Radio value={"是"}>是</Radio>
                                <Radio value={"否"}>否</Radio>
                            </Radio.Group>
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    visible={this.state.delete_visible}
                    title={'温馨提示'}
                    onOk={this.deleteProject}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.deleteProject}>
                            确定
                        </Button>,
                    ]}
                >
                    <div>确定删除该项目吗？</div>
                </Modal>
            </div>
            </div>
        )
    }
}
export default ProjectList;